import React from 'react';
import BioVitalDetailList from '../bio-vitals/BioVitalDetailList';

// Water intake detail list (reached from /user-bio-vitals Water Count drill-down).
const WaterDetailsList = () => (
  <BioVitalDetailList config={{
    title: 'Water Intake Details',
    routePath: '/water-details',
    endpoint: '/admin/api/water-details',
    valueLabel: 'Water Intake',
    valueKey: 'water_intake',
    dateLabel: 'Created At',
    dateKey: 'created_at',
    dateFmt: 'last',
    totalLabel: 'Total Water Intake',
    breadcrumbType: 'Water',
    exportName: 'water-details.csv',
  }} />
);

export default WaterDetailsList;
